import React, { useState, useEffect } from 'react';
import './TestimonialsSection.css';

const TestimonialsSection = () => {
  const [isLoading, setIsLoading] = useState(true);
  const [images, setImages] = useState([]);
  const [error, setError] = useState(null);
  const [viewportWidth, setViewportWidth] = useState(window.innerWidth);

  useEffect(() => {
    const loadImages = async () => {
      try {
        // Assuming we have 10 pages, adjust the number based on your actual images
        const imageCount = 10;
        const imageUrls = Array.from({ length: imageCount }, (_, i) => 
          `/assets/testimonials/testimonials_page-${String(i + 1).padStart(4, '0')}.jpg`
        );
        
        // Preload images
        const imagePromises = imageUrls.map(url => {
          return new Promise((resolve, reject) => {
            const img = new Image();
            img.src = url;
            img.onload = () => resolve(url);
            img.onerror = () => reject(new Error(`Failed to load ${url}`));
          });
        });

        const loadedImages = await Promise.all(imagePromises);
        setImages(loadedImages);
        setIsLoading(false);
      } catch (err) {
        console.error('Failed to load images:', err);
        setError('Failed to load testimonial images');
        setIsLoading(false);
      }
    };
    
    loadImages();
  }, []);

  useEffect(() => {
    const handleResize = () => setViewportWidth(window.innerWidth);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const getResponsiveWidth = () => {
    if (viewportWidth < 768) return '95%';
    if (viewportWidth < 1024) return '90%';
    return '800px';
  };

  return (
    <div className="testimonials-container">
      <h2 className="testimonials-title">What Our Students Say</h2>
      <p className="testimonials-subtitle">Authentic handwritten feedback from our amazing students</p>
      
      <div className="pdf-viewer-container" style={{ width: getResponsiveWidth() }}>
        {isLoading ? (
          <div className="loading-spinner">
            <div className="spinner"></div>
            <p>Loading testimonials...</p>
          </div>
        ) : error ? (
          <div className="error-message">
            <p>{error}</p>
          </div>
        ) : (
          <div className="testimonials-images-container">
            {images.map((imageUrl, index) => (
              <img 
                key={index}
                src={imageUrl}
                alt={`Testimonial page ${index + 1}`}
                className="testimonial-image"
              />
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default TestimonialsSection;